// src/components/About/CoreValues.tsx
import React from 'react';
import { FaHandsHelping, FaBookOpen, FaUsers, FaShieldAlt } from 'react-icons/fa';
import {

  CoreValuesGrid,
  CoreValueItem,

} from './CoreValues.styles';

import { SectionContentWrapper, GlassContainer, WhiteCard } from '../About.styles';

const coreValues = [
  {
    icon: <FaHandsHelping size={40} />,
    title: 'Compassion',
    description: 'Uplifting each individual with empathy, kindness, and heartfelt care.',
  },
  {
    icon: <FaBookOpen size={40} />,
    title: 'Education',
    description: 'Equipping communities with knowledge, tools, and confidence to thrive.',
  },
  {
    icon: <FaUsers size={40} />,
    title: 'Community',
    description: 'Fostering networks of support that bring people together in solidarity and strength.',
  },
  {
    icon: <FaShieldAlt size={40} />,
    title: 'Integrity',
    description: 'Acting with honesty, accountability, and transparency in all we do.',
  },
];

const CoreValues: React.FC = () => {
  return (
    <GlassContainer>
      <WhiteCard>
        <SectionContentWrapper>
          <h2>
            <FaHandsHelping style={{ marginRight: '0.5rem', color: '#673AB7' }} />
            Our Core Values
          </h2>
          <CoreValuesGrid>
            {coreValues.map((value, index) => (
              <CoreValueItem key={index}>
                {value.icon}
                <h3>{value.title}</h3>
                <p>{value.description}</p>
              </CoreValueItem>
            ))}
          </CoreValuesGrid>
        </SectionContentWrapper>
      </WhiteCard>
    </GlassContainer>
  );
};

export default CoreValues;
